import './TwoWaySwitch.scss'
import React from 'react'
import classNames from 'classnames'

export interface TwoWaySwitchProps {
  leftOption: string
  rightOption: string
  selectedOption: string
  onChange: (option: any) => void
}

export const TwoWaySwitch: React.FC<TwoWaySwitchProps> = ({ leftOption, rightOption, selectedOption, onChange }) => {
  const handleOnChange = () => {
    onChange(leftOption === selectedOption ? rightOption : leftOption)
  }
  return (
    <div onClick={handleOnChange} className='two-way-switch__container' role='button'>
      <div
        className={classNames('two-way-switch__left-option', {
          'two-way-switch__option--selected': leftOption === selectedOption,
        })}
      >
        {leftOption}
      </div>
      <div
        className={classNames('two-way-switch__right-option', {
          'two-way-switch__option--selected': rightOption === selectedOption,
        })}
      >
        {rightOption}
      </div>
    </div>
  )
}
